import { licensee } from "tap/pages/TPRExceptions/components/grid/config/columns";
import { CASES } from "./constants";
import { safeGetJSON } from "tap/utils/safeLocalStorage";
import {
  DEFAULT_PAGE_SIZE_OPTIONS,
  getInitialPaginationRange,
  getStoredItemsPerPage,
  PAGINATION_STORAGE_KEYS,
  persistItemsPerPageFromPayload,
  withPreservedPagination,
} from "tap/utils/paginationPreferences.js";

const paginationKeys = {
  itemsPerPage: PAGINATION_STORAGE_KEYS.tprExceptions,
};
const initialItemsPerPage = getStoredItemsPerPage(paginationKeys.itemsPerPage);
const initialPaginationRange = getInitialPaginationRange(initialItemsPerPage);

const getInitialTPRExceptionsSort = () => {
  return safeGetJSON("tprExceptionsSort", ["exceptionTimeStamp", "DESC"]);
};

const initialState = {
  tprExceptions: [],
  refreshTPRExceptions: 0,
  filterForm: {
    tprReleaseId: "",
    tprReleaseTitle: "",
    mineOnly: true,
    catalogName: "",
    licensee: "",
    dealId: "",
    catalogId: "",
    users: "",
    territories: "",
    medias: "",
    exceptionStatus: "",
    exceptionType: "",
  },
  exceptionTypeOptions: [
    { value: "DEAL_MANAGEMENT", label: "Deal Management" },
    { value: "DIGITAL_STORES", label: "Digital Stores" },
    { value: "TECHNOLOGY", label: "Technology" },
  ],
  exceptionStatusOptions: [
    { value: "NEW", label: "New" },
    { value: "RESOLVED", label: "Resolved" },
    { value: "DISMISSED", label: "Dismissed" },
  ],
  userOptions: [],
  userOptionsRevision: 0,
  territoryOptions: [],
  mediaOptions: [],
  totalPages: 0,
  totalItems: 0,
  currentPage: 0,
  filterParam: "",
  tprExceptionsRange: initialPaginationRange,
  tprExceptionsSort: getInitialTPRExceptionsSort(),
  defaultFilterRange: initialPaginationRange,
  itemsPerPage: initialItemsPerPage,
  pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
};

export function tprExceptions(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CASES.UPDATE_TPR_EXCEPTIONS: {
      persistItemsPerPageFromPayload(payload, paginationKeys);
      return { ...state, ...payload };
    }
    case CASES.UPDATE_TPR_EXCEPTIONS_SEARCH_FORM: {
      const { data, key } = payload;
      return { ...state, [key]: { ...state[key], ...data } };
    }
    case CASES.CLEAR_TPR_EXCEPTIONS: {
      return withPreservedPagination(
        state,
        {
          ...initialState,
          filterForm: {
            ...initialState.filterForm,
            mineOnly:
              state.filterForm?.mineOnly ?? initialState.filterForm.mineOnly,
          },
          tprExceptionsSort: state.tprExceptionsSort,
          userOptions: state.userOptions,
          exceptionStatusOptions: state.exceptionStatusOptions,
          exceptionTypeOptions: state.exceptionTypeOptions,
          territoryOptions: state.territoryOptions,
          mediaOptions: state.mediaOptions,
        },
        ["tprExceptionsRange"],
      );
    }
    default:
      return state;
  }
}
